import {
  faArrowsRotate,
  faCircleCheck,
  faClipboardList,
  faClockRotateLeft,
  faClone,
  faListOl,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'src/components/loader';
import StatusBadge from 'src/components/ui/StatusBadge';
import { useRequirementRevisions } from 'src/hooks/services/useMaintenance';
import { useDateLocale } from 'src/hooks/useDateLocale';
import { getStepCount, summarizeFrequency } from 'src/utils/maintenance';

const VersionHistorySheet = ({ requirement }) => {
  const { formattedDate } = useDateLocale();
  const rootUri = requirement.root_requirement || requirement.uri;
  const { data: revisions = [], isLoading } = useRequirementRevisions(rootUri);

  return (
    <div className='mnt-sheet'>
      <p className='text-muted' style={{ fontSize: 12.5 }}>
        <strong>{requirement.name}</strong>: each past event keeps the exact version it was
        performed under.
      </p>

      {isLoading ? (
        <Loader />
      ) : (
        revisions.map(revision => {
          const isCurrent = !revision.superseded_at;
          return (
            <div
              key={revision.uri}
              className={classNames('mnt-revision', isCurrent && 'mnt-revision--current')}
            >
              <span className='mnt-revision__icon'>
                <FontAwesomeIcon icon={isCurrent ? faCircleCheck : faClockRotateLeft} />
              </span>
              <div className='mnt-revision__body'>
                <div className='mnt-revision__top'>
                  <span className='mnt-revision__name'>Version {revision.revision_number}</span>
                  {isCurrent ? (
                    <StatusBadge size='sm' tone='outline' uppercase={false} variant='success'>
                      Current
                    </StatusBadge>
                  ) : (
                    <StatusBadge size='sm' tone='outline' uppercase={false} variant='warning'>
                      Older version
                    </StatusBadge>
                  )}
                </div>
                <div className='mnt-revision__cadence'>
                  <FontAwesomeIcon icon={faArrowsRotate} /> {summarizeFrequency(revision)}
                </div>
                {revision.supersedes && (
                  <div className='mnt-revision__meta'>
                    <FontAwesomeIcon icon={faClone} /> Checklist copied from an earlier version
                  </div>
                )}
                {revision.work_checklist?.name && (
                  <div className='mnt-revision__meta'>
                    <FontAwesomeIcon icon={faClipboardList} /> {revision.work_checklist.name}
                    {' · '}
                    <FontAwesomeIcon icon={faListOl} /> {getStepCount(revision)}{' '}
                    {getStepCount(revision) === 1 ? 'step' : 'steps'}
                  </div>
                )}
                {revision.superseded_at && (
                  <div className='mnt-revision__meta'>
                    <FontAwesomeIcon icon={faClockRotateLeft} /> Superseded{' '}
                    {formattedDate(revision.superseded_at)}
                  </div>
                )}
              </div>
            </div>
          );
        })
      )}

      {!isLoading && revisions.length === 0 && (
        <div className='text-center text-muted'>No version history yet.</div>
      )}
    </div>
  );
};

VersionHistorySheet.propTypes = {
  requirement: PropTypes.object.isRequired,
};

export default VersionHistorySheet;
